import { Tooltip, Typography } from '@mui/material';

import { useThreadSummaryTimestamp } from './ThreadSummaryTimestamp.hook';

export const ThreadSummaryTimestamp = ({ timestamp }: { timestamp: Date }) => {
  const { displayValue, tooltipValue } = useThreadSummaryTimestamp(timestamp);

  return (
    <Tooltip title={tooltipValue}>
      <Typography variant="caption" color="text.secondary" maxWidth={75} textAlign="end" flexBasis={'50%'}>
        {displayValue}
      </Typography>
    </Tooltip>
  );
};
